import { ReactNode } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackPullRequestItem } from "shared/Stack/useStackPullRequests/gql";

import { isStackPullRequestExpandable } from "../../helpers";
import StackPullRequestsTablePullRequestGroupToggle from "./PullRequestGroupToggle";

type StackPullRequestsTableGroupCellProps = TableSimpleCellProps<StackPullRequestItem> & {
  stackId: string;
  children: ReactNode;
};

const StackPullRequestsTableGroupCell = ({
  item: pullRequest,
  stackId,
  isFirst,
  children,
  ...cellProps
}: StackPullRequestsTableGroupCellProps) => {
  const isActive = isFirst && isStackPullRequestExpandable(pullRequest.runs);

  return (
    <TableSimpleCell {...cellProps}>
      {isActive && (
        <StackPullRequestsTablePullRequestGroupToggle pullRequest={pullRequest} stackId={stackId}>
          {children}
        </StackPullRequestsTablePullRequestGroupToggle>
      )}

      {!isActive && children}
    </TableSimpleCell>
  );
};

export default StackPullRequestsTableGroupCell;
